import { en } from './en'
import { fr } from './fr'

export const impactPage = {
  en,
  fr
}